import { arrayField } from "@common";
import * as cn from "classnames";
import * as React from "react";
import { FieldError } from "../ErrorMessage";
import { GenderMapping } from "@store";
import { PremiumFeatureIcon } from "../PremiumFeatureIcon";

export interface GenderComponentProps {
    value: string[] | null;
    field: any | null;
    onChange: { events: any };
    isDisabled: boolean;
    onCheckBoxAction: (fieldName: string) => void;
    genderMapping: GenderMapping[];
    // Other props here
}

export interface GenderComponentState {
    isHintShown: boolean;
}

export class GenderComponent extends React.Component<GenderComponentProps, GenderComponentState> {
    constructor(props: GenderComponentProps) {
        super(props);
        this.state = {
            isHintShown: false
        };
        this.showHint = this.showHint.bind(this);
    }

    handleChange(e: any, field: any, events: any, value: string) {
        const checkboxesWithoutUnknown = this.props.value.filter(v => v !== "Unknown");
        if (checkboxesWithoutUnknown.length === 1 && value !== "Unknown" && value === checkboxesWithoutUnknown[0]) {
            return this.showHint();
        }
        if (value === "Unknown") {
            return arrayField.toCheckbox.events(field, events, value).onChange(e, true);
        }
        arrayField.toCheckbox.events(field, events, value).onChange(e);
    }

    showHint() {
        this.setState({
            ...this.state,
            isHintShown: true
        });
        setTimeout(
            () =>
                this.setState({
                    ...this.state,
                    isHintShown: false
                }),
            2000
        );
    }

    render() {
        const { field, onChange, isDisabled, onCheckBoxAction, genderMapping } = this.props;
        const { isHintShown } = this.state;

        return (
            <>
                <div className="premium-block-wrapper">
                    <label className="common-checkbox custom-premium-checkbox gender-premium-checkbox tour-campaign-gender-targeting">
                        <input
                            type="checkbox"
                            name="Enable Gender Targeting"
                            value="gender"
                            checked={!isDisabled}
                            onChange={e => onCheckBoxAction(e.target.value)}
                        />
                        Enable Gender Targeting
                        <span className="checkmark" />
                    </label>
                    <PremiumFeatureIcon status="trial" />
                </div>
                <div className={cn("sub-check-boxes-wrapper strict__checkbox-wrapper", field.visualState)}>
                    {genderMapping &&
                        genderMapping.map((gender: GenderMapping, index: number) => (
                            <label
                                key={index}
                                className={cn(
                                    "common-checkbox custom-gender-checkbox strict__checkbox",
                                    isDisabled ? "common-checkbox__isDisabled" : "",
                                    gender.type === "Unknown" ? "targeting__checkbox_strict" : ""
                                )}
                            >
                                <input
                                    type="checkbox"
                                    name="gender"
                                    value={gender.type}
                                    checked={
                                        isDisabled
                                            ? false
                                            : gender.type === "Unknown"
                                                ? !arrayField.toCheckbox.checked(field, gender.type)
                                                : arrayField.toCheckbox.checked(field, gender.type)
                                    }
                                    onChange={e => this.handleChange(e, field, onChange.events, gender.type)}
                                    disabled={isDisabled}
                                />
                                {gender.type === "Unknown" ? "Use strict targeting" : gender.type}
                                <span className="checkmark" />
                            </label>
                        ))}
                </div>
                <FieldError field={field} />
                <span className={cn(`targeting__hint`, isHintShown ? "targeting__hint_visible" : "")}>
                    At least one targeting option must be selected
                </span>
            </>
        );
    }
}
